<template>
	<div class="page-show" v-html="text"></div>
</template>

<script>
	import axios from 'axios'
	export default {
		data(){
			return {
				text: '获取中...'
			}
		},
		created() {
			this.axios({
				method: 'get',
				url: 'https://app.zhifuren.com.cn/tpos-api/api/protocol/20',
			}).then(res => {
				console.log(res)
				this.text = res.data.data.protocolContent;
			})
		}
	}
</script>

<style scoped lang="scss">
	.page-show{
		padding: 1rem;
		text-align: left;
	}
</style>
